import { COMPANY_FILTER_CHANGE } from 'containers/PartnerOptions/constants'

import { GET_DATA_ASYNC, TOGGLE_DETECTION_CHANGE, UPDATE_DATA_ASYNC } from './constants'

export default function () {
  const initialState = {
    loader: false,
    data: {},
    error: null,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case COMPANY_FILTER_CHANGE:
      case GET_DATA_ASYNC.INITIATE:
        return { ...state, loader: true, error: null }
      case GET_DATA_ASYNC.SUCCESS:
        return { ...state, loader: false, data: action.payload.data }
      case GET_DATA_ASYNC.ERROR:
        return { ...state, error: action.error, loader: false }
      case GET_DATA_ASYNC.CANCEL:
        return { ...state, loader: false }
      case UPDATE_DATA_ASYNC.INITIATE:
        return { ...state, error: null, loader: true }
      case UPDATE_DATA_ASYNC.SUCCESS:
      case UPDATE_DATA_ASYNC.CANCEL:
        return { ...state, loader: false }
      case UPDATE_DATA_ASYNC.ERROR:
        return { ...state, loader: false, error: action.error }
      case TOGGLE_DETECTION_CHANGE:
        return {
          ...state,
          data: {
            ...state.data,
            ...action.payload,
          },
        }
      default:
        return state
    }
  }
}
